import React from 'react';
import { Field, Input, Button, SaveBar, uid, move } from './ui';
import useDraft from './useDraft';

export default function GalleryEditor({ stored }) {
  const { draft, setDraft, dirty, saving, error, save, reset } = useDraft('gallery', stored);

  const patch = (id, next) => setDraft((d) => d.map((g) => (g.id === id ? next : g)));

  return (
    <div>
      <div className="mb-4 flex flex-wrap items-center gap-3">
        <Button variant="dark" onClick={() => setDraft((d) => [...d, { id: uid('g'), src: '/img/slike/', caption: '' }])}>
          + Nova slika
        </Button>
        <span className="text-xs text-slate-500">
          Slike ubaci u <code className="rounded bg-slate-100 px-1">public/img/slike/</code> pa ovdje upiši putanju. Može i puni URL.
        </span>
      </div>

      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {draft.map((g, idx) => (
          <div key={g.id} className="rounded-lg border border-slate-200 bg-white p-3">
            <div className="mb-2 aspect-[4/3] overflow-hidden border border-slate-200 bg-slate-100">
              <img
                src={g.src}
                alt=""
                className="h-full w-full object-cover"
                onError={(e) => { e.target.style.opacity = 0.15; }}
                onLoad={(e) => { e.target.style.opacity = 1; }}
              />
            </div>
            <div className="space-y-2">
              <Field label="Putanja">
                <Input value={g.src} onChange={(e) => patch(g.id, { ...g, src: e.target.value })} />
              </Field>
              <Field label="Opis" hint="Neobavezno (alt tekst).">
                <Input value={g.caption || ''} onChange={(e) => patch(g.id, { ...g, caption: e.target.value })} />
              </Field>
              <div className="flex gap-1">
                <Button className="!px-2 !py-1" onClick={() => setDraft((d) => move(d, idx, idx - 1))}>←</Button>
                <Button className="!px-2 !py-1" onClick={() => setDraft((d) => move(d, idx, idx + 1))}>→</Button>
                <Button
                  variant="danger" className="!px-2 !py-1 ml-auto"
                  onClick={() => setDraft((d) => d.filter((x) => x.id !== g.id))}
                >Obriši</Button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {draft.length === 0 && <p className="py-8 text-center text-sm text-slate-400">Galerija je prazna.</p>}

      <SaveBar dirty={dirty} saving={saving} error={error} onSave={save} onReset={reset} count={draft.length} />
    </div>
  );
}
